// Services Img Imports
import Storage1 from "../assets/images/Services/services-1.png";
import Storage2 from "../assets/images/Services/services-2.jpg";
import Storage3 from "../assets/images/Services/services-3.jpg";

export const Services = [
  {
    title: "State-of-the-Art Facilities",
    imageUrl: Storage1,
    animation: "left",
    description:
      "Our cold storage facility ensures your goods are stored in optimal conditions with cutting-edge technology and robust infrastructure.",
  },
  {
    title: "Preserving Local Produce",
    imageUrl: Storage2,
    animation: "up",
    description:
      "From tamarind to mahua, we are equipped to preserve a variety of local produce, supporting farmers and distributors across the region.",
  },
  {
    title: "Logistics & Efficiency",
    imageUrl: Storage3,
    animation: "right",
    description:
      "With our integrated weighing bridge and seamless logistics, we ensure precise measurements and efficient handling of your products.",
  },
];
